import { render, staticRenderFns } from "./useFireApprove.vue?vue&type=template&id=56f16da0&"
import script from "./useFireApprove.vue?vue&type=script&lang=js&"
export * from "./useFireApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports